import React,{useState,useEffect} from 'react'
import styled from '@emotion/styled'
import LoadingComponent from '../shared/LoadingComponent';

const Container = styled.div`
    /* display:grid;
    grid-auto-flow:row;
    grid-gap:1rem; */
    display: flex;
    flex-direction: column;
    
    @media (max-width: 768px){
      
    }

 
`;
const Header = styled.h1`
    font-weight: 500;
    font-size: var(--font-32);
    line-height: var(--space-32);
    color:var(--color-gray-800);
    padding-bottom: 2rem;

    @media (max-width:500px){
        font-size: var(--font-24);
    }

`;
const Text = styled.p`
    font-style: normal;
    font-weight: normal;
    width:38rem;
    font-size: var(--font-16);
    line-height: var(--space-24);
    color:var(--color-gray-800);

    @media (max-width:500px){
        width:auto;
    }
    @media only screen and (max-width: 500px) {
    
    }
`;

const ImageContainer = styled.div`
    margin-top:5rem;
    display:grid;
    grid-auto-flow:column;
    width:10rem;
    grid-gap:2rem;
    
    @media (max-width: 768px){
      width:1rem;
    }
    @media (max-width:500px){
        margin-top: 2rem;
        width: 0.5rem;
        grid-auto-flow:row;
    }
 
`;
const ImageLayout = styled.div`
    display:grid;
    grid-auto-flow:row;
    grid-gap:3rem;

    @media only screen and (max-width: 500px) {
        margin-top: 5rem;
        display: flex;
        flex-direction: column;
    }
   
`;
const VerticalContainer = styled.div`
    display:grid;
    grid-auto-flow:row;
    justify-content:center;
    grid-gap:0.5rem;

    img{
        border-radius:12px;
    }
    @media (max-width: 768px){
       img{
           width:10rem;
       }

    }
    @media (max-width:500px){
        img{
            width: 5rem;
            height: 5rem;
            object-fit: cover;
            object-position: top;
        }
        grid-gap:0.5rem;
        grid-auto-flow:column;
        align-items: center;

        .text{
            display:grid;
            height:4rem;
            grid-auto-flow:row;
        }
        .divider{
            width: 14.625rem;
            height: 1px;
            background: var(--divider-gradient);
        }
    }
`;
const ImageHeader = styled.h1`
    padding-top:1rem;
    font-weight: 600;
    font-size: var(--font-20);
    line-height: var(--space-20);
    color:var(--company-dark);
    width:100%;
 
    white-space: nowrap;

    @media (max-width:500px){
        padding-top: 0.5rem;
        font-size: var(--font-16);
        font-weight: 500;
    }
`;
const ImageText = styled.p`
    font-weight: 600;
    justify-self:center;
    font-size: var(--font-16);
    line-height: var(--space-16);
    color:var(--color-gray-800);
    width:100%;
    text-align:center;
    white-space: nowrap;

    @media (max-width:500px){
        font-size: var(--font-14);
        font-weight: 500;
        text-align: inherit;
    }
`;


const Who = () => {
    const [loading,setLoading] = useState(true);

    useEffect(()=>{
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    })
    return (
        <>
        {loading ?
            <div style={{marginLeft:"2rem"}}>
                 <LoadingComponent/>
            </div>   
        :    
        <Container>
           
            <Header>We Are IRAD</Header>
            <Text>Unsure of what your projected procedure entails?
             Still nervous about going through with it?
              We’re here to keep you informed, without sugar-coating the process.
               Find your procedure below and we’ll walk you through.</Text>
            <ImageLayout>
                <ImageContainer>
                    <VerticalContainer>
                        <img src="/irad-team/j-avante.jpg"/>
                        <VerticalContainer className="text">
                            <ImageHeader>Jessica Avante</ImageHeader>
                            <ImageText>Help Desk</ImageText>
                            <div className="divider"></div>
                        </VerticalContainer>
                    </VerticalContainer>

                    <VerticalContainer>
                        <img src="/irad-team/m-eggestein.jpg"/>
                        <VerticalContainer className="text">
                            <ImageHeader>Maureen Eggestein</ImageHeader>
                            <ImageText>Chief Financial Officer</ImageText>
                            <div className="divider"></div>
                        </VerticalContainer>
                    </VerticalContainer>

                    <VerticalContainer>
                        <img src="/irad-team/a-martin.jpg"/>
                        <VerticalContainer className="text">
                            <ImageHeader>Angela Martin</ImageHeader>
                            <ImageText>Order Fulfillment</ImageText>
                            <div className="divider"></div>
                        </VerticalContainer>
                    </VerticalContainer>
                    
                </ImageContainer>
                <ImageContainer>

                    <VerticalContainer>
                        <img src="/irad-team/g-munroe.jpg"/>
                        <VerticalContainer className="text">
                            <ImageHeader>Geena Munroe</ImageHeader>
                            <ImageText>Help Desk</ImageText>
                            <div className="divider"></div>
                        </VerticalContainer>
                    </VerticalContainer>

                    <VerticalContainer>
                        <img src="/irad-team/j-homewood.jpg"/>
                        <VerticalContainer className="text">
                            <ImageHeader>Jonathan Homewood</ImageHeader>
                            <ImageText>Inventory Manager</ImageText>
                            <div className="divider"></div>
                        </VerticalContainer>
                    </VerticalContainer>

                    <VerticalContainer>
                        <img src="/irad-team/r-johnson.jpg"/>
                        <VerticalContainer className="text">
                            <ImageHeader>Remmington Johnson</ImageHeader>
                            <ImageText>Operations Manager</ImageText>
                            <div className="divider"></div>
                        </VerticalContainer>
                    </VerticalContainer>
                    
                </ImageContainer>
            </ImageLayout>
        </Container>
    }
    </>
    )
}

export default Who
